const cdnBaseUrl = import.meta.env.VITE_PUBLIC_CDN_BASE_URL

const appLogo = cdnBaseUrl + 'images/logo.webp'

const testimonialImage = {
  ardakani: cdnBaseUrl + 'images/testimonial_ardakani.webp',
  banijavad: cdnBaseUrl + 'images/testimonial_banijavad.webp',
  khodarahmi: cdnBaseUrl + 'images/testimonial_khodarahmi.webp',
  khodaverdi: cdnBaseUrl + 'images/testimonial_khodaverdi.webp',
  mohammadi: cdnBaseUrl + 'images/testimonial_mohammadi.webp',
  alizadeh: cdnBaseUrl + 'images/testimonial_alizadeh.webp',
  nikpoor: cdnBaseUrl + 'images/testimonial_nikpoor.webp',
  roomi: cdnBaseUrl + 'images/testimonial_roomi.webp',
  shaterhoseini: cdnBaseUrl + 'images/testimonial_shaterhoseini.webp'
}

const merchantDocument = {
  payment: cdnBaseUrl + 'images/fish_hoghooghi.webp',
  locationDocument: cdnBaseUrl + 'images/location_document.webp',
  license: cdnBaseUrl + 'images/mojavez_faaliyat.webp',
  userDocument: cdnBaseUrl + 'images/useri_document.webp'
}

const notFound = 'https://s3.dgstack.ir/landing/404.svg'

export { merchantDocument, testimonialImage, appLogo, notFound }
